import { OFFICE_LOAD_INFO, OFFICE_LOAD_INFO_INIT } from "../actions/types";
const initialState = {
	allOffice: [],
	isLoaded:false,
};
export default function (state = initialState, action) {
	switch (action.type) {
		case OFFICE_LOAD_INFO:
			return {
				...state,

				allOffice: action.payload,
				isLoaded:true
			};
			case OFFICE_LOAD_INFO_INIT:
			return {
				...state,
	             isLoaded:false,
			};


		default:
			return state;
	}
}
